require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-nepal-rani-jamara-kuleriya-irrigation.json") })
        }
      }, "path---en-us-update-nepal-rani-jamara-kuleriya-irrigation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-nepal-rani-jamara-kuleriya-irrigation!./.cache/json/en-us-update-nepal-rani-jamara-kuleriya-irrigation.json
// module id = 779
// module chunks = 231608221292675